import { Meta } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { ApiConnectionService } from '../services/api-connection.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { TranslateServiceService } from '../services/translate-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'runner',
  templateUrl: './runner.component.html',
  styleUrls: ['./runner.component.scss']
})
export class RunnerComponent implements OnInit {

  name: string;
  description: string;
  totalCollected: number;
  quantityDonors: number;
  teamCollector: string;
  avatarCollector: string;
  istRecurrent: boolean;
  taxRegimens: any = [];
  invoiceTaxRegimen: string = '';
  // NgModels
  transactionEmail: string = '';
  transactionPhone: string = '';
  transactionName: string = '';
  transactionLastName: string = '';
  transactionCollectorId: string;
  transactionAlias: string;
  // Transacion NgModels
  cardNumber: string = '';
  cardName: string = '';
  cardDate: string = '';
  cardExpMonth: any = "";
  cardExpYear: any = "";
  cardCvv: string = '';
  //Config transaction
  recurrent: boolean = false;
  anonymous: boolean = false;
  planId: string = '';
  amountSelected: string;
  ipDonor: string = "127.0.0.1";
  ltDonor: string = "1234";
  lgDonor: string = "1234";
  teamId: string = '';
  personId: string = '';
  msgTransaction: string = '';
  fiscalData: boolean = false;
  termsAndConditions: boolean = false;
  transactionId: string;
  brand: string;
  lastFour: string;
  termsConditionsRequired: boolean = false;
  thanksText: string;
  allowRecurrent: boolean = false;
  cardBrand: string = "VISA";
  theRaceEnd: boolean = false;
  collectorTeam: string;
  collectorUsername: string;
  privacyDataAllowed: boolean = false;
  urlResponse: string = '';
  transactionIdBbva: string = '';
  // Fiscal ngModels
  rfc: string;
  country: any = 0;
  colony: string;
  extNumber: string = '';
  intNumber: string = '';
  birthDate: string;
  socialConcept: string;
  postalCode: string;
  street: string;
  gender: string;
  township: string = '';
  locality: string = '';
  municipality: string = '';
  state: string = '';
  iNeedInvoice: boolean = false;
  // Amounts
  amountList: any;
  selectedAmountIndex: any = null;
  customAmount: any = false;
  textAmount: any = null;
  // Plans
  planList: any;
  isPlan: boolean = false;
  // Race Info
  raceId: string;
  messageDonor: boolean = true;
  // Form Group
  checkoutForm: FormGroup;
  postalCodeForm: FormGroup;
  // Regex validation
  emailRegex: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  rfcRegex: any = /^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))((-)?([A-Z\d]{3}))?$/;
  phoneRegex: any = /\d{8,10}/;
  cardRegex: any = /\d{13,18}/;
  expirationRegex: any = /\d{2}/;
  cvvRegex: any = /\d{3,4}/;
  // Switch views
  donorCreated: boolean = false;
  transactionCreated: boolean = false;
  // Loader
  showLoader: boolean = false;
  // Form errors
  emptyFieldDonor: boolean = false;
  emptyFieldTransaction: boolean = false;
  emptyFieldInvoice: boolean = false;
  serverErr: boolean = false;
  serverErrText: any;
  termsAndConditionErr: boolean = false;
  privacyDataAllowedErr: boolean = false;
  hasNotAmountErr: boolean = false;
  emailRegexErr: boolean = false;
  rfcRegexErr: boolean = false;
  phoneRegexErr: boolean = false;
  captchaErr: boolean = false;
  cardExpMonthFixErr: boolean = false;
  cardExpYearErr: boolean = false;
  postalCodeErr: boolean = false;
  emailRegexField: boolean = false;
  rfcRegexField: boolean = false;
  phoneRegexField: boolean = false;
  greaterThanAllowedErr = false;
  lessThanAllowedErr = false;
  // Race config
  logoRace: string;
  goalBarBg: string;
  // Global loader
  arePageReady: boolean = false;
  // Privacy Config
  privacyUrl: string;
  // Runner Info
  avatar: any;
  bannerAvatar: any = 'assets/images/corredor.jpg';
  // Translate Service
  text: any = {
    donor_info_section: {}
  };
  notCurrentLanguage: string;
  currentLanguageNav: string = "es";
  // Donors list
  donorsList: any;
  showDonorList: boolean = false;
  // Social Network
  socialNetworkMessageActive: boolean = true;
  socialNetworkMessage: string = '';
  hideFB: boolean = false;
  // Hide alias validation
  withoutAlias: boolean = false;
  // Year today
  yearTodayWorld: any;
  // Clipboard
  copiedClipboard: boolean = false;
  // Captcha
  captchaApproved: string = '';
  // Pass input
  donorPastInput: any;
  // Show data in card
  showCvvCard: string;
  // Esto es Dev:
  //urlASForm: string = 'https://solutions.asf.edu.mx/RecaudiaTest/getTransaction.aspx'
  // Esto es Prod:
  urlASForm: string = 'https://giving.asf.edu.mx/running/getTransaction.aspx'

  showOther: boolean = false

  constructor(
    private apiService: ApiConnectionService,
    private formBuilder: FormBuilder,
    private translateService: TranslateServiceService,
    private meta: Meta,
    private router: Router
  ) {
    const _ = this;
    _.text.transaction_section = {};
    _.getCurrentLanguage();
  }

  ngOnInit() {
    const _ = this;
    _.checkoutValidationForm();
    _.getRaceData();
    _.yearToday();
    _.getTaxRegimens();
    _.checkoutPostalCodeValidationForm();
    _.isStatusView();
    window.scrollTo(0, 0);
    _.meta.updateTag({ property: 'og:image', content: 'https://carreravirtualmt.blob.core.windows.net/logos/logoh-carrera_kardias_2019.png' });
    // if(_.getMerchant() != 'kardias'){
    //   _.hideFB = true;
    // }
  }

  ngAfterViewInit(){
    const _ = this;
    _.getInfoCollector();
    _.getQuantities();
    _.meta.updateTag({ property: 'og:image', content: 'https://carreravirtualmt.blob.core.windows.net/logos/logoh-carrera_kardias_2019.png' });
    _.getPages();
  }

  isStatusView(){
    const _ = this;
    let isStatusView = _.router.url.split("/")[5] == 'status';
    if(isStatusView){
      _.donorCreated = true;
      _.transactionCreated = true;
    }
  }

  withoutSpaces(){
    let _ = this;
    _.transactionEmail = _.transactionEmail.replace(' ','');
  }

  getCurrentLanguage() {
    const _ = this;
    let isEN = _.translateService.getCurrentLanguage() === 'EN';
    _.translateService.getJSON("assets/translations/runner.translations.json")
      .subscribe((res) => {
        if(isEN){
          _.text = res.english;
          _.notCurrentLanguage = 'ES';
          _.currentLanguageNav = 'en';
        }else{
          _.text = res.spanish;
          _.notCurrentLanguage = 'EN';
          _.currentLanguageNav = 'es';
        }
      });
  }

  buttonShowOther(){
    const _ = this;
    _.showOther = true;
  }

  getQuantities(){
    const _ = this;
    let conditions = {
      "conditions":{
        "race_url": _.getRaceName(),
        "active": true,
      },
      "merchant": _.getMerchant(),
    }

    _.apiService.getQuantities(conditions).subscribe(data => {
      _.messageDonor = data['results'][0].message_donor;
      _.socialNetworkMessageActive = data['results'][0].design.social_media_message.active;
      _.allowRecurrent = data['results'][0].enable_recurrent;
      _.logoRace = data['results'][0].design.images.logo_header;
      _.goalBarBg = data['results'][0].design.color.secundary;
      if(_.allowRecurrent){
        _.getPlans();
      }
      _.theRaceEnd = _.validateRaceDate(data['results'][0].end_date) ?  true : false
      if(_.socialNetworkMessageActive){
        _.socialNetworkMessage = data['results'][0].design.social_media_message[_.currentLanguageNav];
      }
      if(_.currentLanguageNav == 'es'){
        _.thanksText = data['results'][0].design.thanks.es.message;
        return;
      }
      _.thanksText = data['results'][0].design.thanks.en.message;
    })
  }

  validateRaceDate(endDate: any){
    let currentDate = new Date();
    let raceDate = new Date(endDate);

    return currentDate > raceDate;
  }

  getRaceData(){
    const _ = this;
    let conditions = {
     "conditions":{
       "race_url": _.getRaceName(),
       "active": true,
     },
      "merchant": _.getMerchant(),
    }

    _.apiService.getQuantities(conditions).subscribe(data => {
      _.raceId = data['results'][0].race_id;
      _.getRaceAmounts();
    })
  }

  getMerchant(){
    const _ = this;
    let merchant: any = location.href.split('/');

    return merchant[3];
  }

  getRaceName(){
    const _ = this;
    let raceName: any = location.href.split('/');

    return raceName[4];
  }

  getTaxRegimens(){
    const params = {
      merchant: this.getMerchant()
    };
    this.apiService.getTaxRegimens(params).subscribe(data => {
      this.taxRegimens = data['results'];
    })
  }

  checkoutValidationForm(){
    const _ = this;
    _.checkoutForm = new FormGroup({
      //Info Step
      emailHomeInput: new FormControl('emailHomeInput', [
        Validators.required,
        Validators.pattern(_.emailRegex)
      ]),

      nameHomeInput: new FormControl('nameHomeInput', Validators.required),
      lastNameHomeInput: new FormControl('lastNameHomeInput', Validators.required),
      phoneHomeInput: new FormControl('phoneHomeInput', [
        Validators.required,
        Validators.pattern(_.phoneRegex)
      ]),
      aliasHomeInput: new FormControl('aliasHomeInput', Validators.required),

      // Transaction step
      cardNumberHomeInput: new FormControl('cardNumberHomeInput', Validators.required),
      cardHolderHomeInput: new FormControl('cardHolderHomeInput', Validators.required),
      expMontHomeInput: new FormControl('expMontHomeInput', Validators.required),
      expYearHomeInput: new FormControl('expYearHomeInput', Validators.required),
      cvvHomeInput: new FormControl('cvvHomeInput', Validators.required),

      // Invoice step
      rfcHomeInput: new FormControl('rfcHomeInput', Validators.required),
      colonyHomeInput: new FormControl('colonyHomeInput', Validators.required),
      extNumHomeInput: new FormControl('extNumHomeInput', Validators.required),
      legalNameHomeInput: new FormControl('legalNameHomeInput', Validators.required),
      postalCodeHomeInput: new FormControl('postalCodeHomeInput', Validators.required),
      streetHomeInput: new FormControl('streetHomeInput', Validators.required),
      taxRegimeHomeInput: new FormControl('taxRegimeHomeInput'),

    });
  }

  checkoutPostalCodeValidationForm(){
    const _ = this;
    _.postalCodeForm = new FormGroup({
      municipalityHomeInput: new FormControl('', Validators.required),
      stateHomeInput: new FormControl('', Validators.required),
      cityHomeInput: new FormControl('', Validators.required),
    });
  }

  getInfoCollector(){
    const _ = this;
    let conditions = {
      "conditions":{
        "username": _.getRunnerName(),
        "race_url": _.getRaceName()
      },
      "merchant": _.getMerchant()
    }
    _.apiService.getCollectors(conditions).subscribe(data => {
      _.teamCollector = data['results'][0].team.name;
      _.avatarCollector = data['results'][0].avatar;
      _.collectorUsername = data['results'][0].username;
      _.collectorTeam = data['results'][0].team.data_2;
      _.bannerAvatar = data['results'][0].banner || 'https://carreravirtualdev.recaudia.com/assets/images/corredor.jpg';
      _.teamId = data['results'][0].team.team_id;
      _.name = data['results'][0].full_name;
      _.description = data['results'][0].description;
      _.totalCollected = data['results'][0].total_collected;
      _.quantityDonors = data['results'][0].quantity_donors;
      _.transactionCollectorId = data['results'][0].user_id;
      _.donorsList = data['results'][0].messages;
      setTimeout(() => {
        _.arePageReady = true;
      }, 1000)
    })
  }

  getRunnerName(){
    let url: any = location.href.split('/');
    url = url[6];
    let withoutQuery: any = url.split('?');
    withoutQuery = withoutQuery[0];
    return withoutQuery;
  }

  getTeamUrl(){
    const _ = this;
    let url: any = _.router.url.split('/');
    url = url[3];
    return url;
  }


  createDonor(){
    const _ = this;
    let conditions = {
      "donor": {
        "name": _.transactionName,
        "lastname": _.transactionLastName,
        "phone": _.transactionPhone.toString(),
        "email": _.transactionEmail.replace(/ /g,""),
        "collector_id": _.transactionCollectorId
      },
      "merchant": _.getMerchant()
    }

    if(
      _.checkoutForm.get('emailHomeInput').hasError('required') ||
      _.checkoutForm.get('phoneHomeInput').hasError('required') ||
      _.checkoutForm.get('nameHomeInput').hasError('required') ||
      _.checkoutForm.get('lastNameHomeInput').hasError('required') ||
      _.checkoutForm.get('aliasHomeInput').hasError('required') && _.messageDonor && !_.anonymous
    ){
      _.emptyFieldDonor = true;
      return;
    }

    if(!_.selectedAmountIndex && (_.amountSelected == "" || _.amountSelected == null) && !_.isPlan){
      _.hasNotAmountErr = true;
      _.emptyFieldDonor = false;

      return;
    }

    if(_.checkoutForm.get('emailHomeInput').hasError('pattern')){
      _.emailRegexErr = true;
      _.emptyFieldDonor = false;
      _.hasNotAmountErr = false;

      return;
    }

    if(_.checkoutForm.get('phoneHomeInput').hasError('pattern')){
      _.phoneRegexErr = true;
      _.emailRegexErr = false;
      _.emptyFieldDonor = false;
      _.hasNotAmountErr = false;

      return;
    }

    _.phoneRegexErr = false;
    _.emptyFieldDonor = false;
    _.hasNotAmountErr = false;
    _.emailRegexErr = false;
    _.showLoader = true;

    _.apiService.createDonor(conditions).subscribe(data => {
        _.showLoader = false;
        _.personId = data['person_id'];
        _.donorCreated = true;
      }
    )
  }

  yearToday(){
    const _ = this;
    const dateToday = new Date();
    let yearToday: any = dateToday.getFullYear();
    yearToday = yearToday.toString().substr(-2);
    _.yearTodayWorld = parseInt(yearToday);
    return parseInt(yearToday);
  }

  createTransaction(){
    const _ = this;
    let cardExpMonthFix = _.cardExpMonth < 10 ? '0' + _.cardExpMonth.toString() : _.cardExpMonth.toString()

    let conditions = {
      "transaction": {
        "person_id": _.personId,
        "card_number": _.cardNumber.toString(),
        "cardholder": _.cardName,
        "exp_month":  cardExpMonthFix,
        "exp_year": '20' + _.cardExpYear.toString(),
        "cvv": _.cardCvv,
        "amount": _.amountSelected,
        "team_id": _.teamId,
        "collector_id": _.transactionCollectorId,
        "recurrent": _.isPlan,
        "plan_id": _.planId,
        "anonymous": _.anonymous,
        "message": _.msgTransaction,
        "name_message": _.transactionAlias,
        "ip": _.ipDonor,
        "lat": _.ltDonor,
        "lng": _.lgDonor
      },
      "merchant": _.getMerchant(),
      "race_url": _.getRaceName(),
    }

    // if(_.captchaApproved == ''){
    //   _.captchaErr = true;
    //   return;
    // }

    if(_.checkoutForm.get('cardNumberHomeInput').hasError('required')){
      //_.captchaErr = false;
      _.emptyFieldTransaction = true;
      _.cardExpYearErr = false;
      _.cardExpMonthFixErr = false;

      return;
    }

    if(_.checkoutForm.get('cardHolderHomeInput').hasError('required')){
      //_.captchaErr = false;
      _.emptyFieldTransaction = true;
      _.cardExpYearErr = false;
      _.cardExpMonthFixErr = false;

      return;
    }

    if(_.checkoutForm.get('expMontHomeInput').hasError('required')){
      //_.captchaErr = false;
      _.emptyFieldTransaction = true;
      _.cardExpYearErr = false;
      _.cardExpMonthFixErr = false;

      return;
    }

    if(_.checkoutForm.get('expYearHomeInput').hasError('required')){
      //_.captchaErr = false;
      _.emptyFieldTransaction = true;
      _.cardExpYearErr = false;
      _.cardExpMonthFixErr = false;

      return;
    }

    if(_.checkoutForm.get('cvvHomeInput').hasError('required')){
      //_.captchaErr = false;
      _.emptyFieldTransaction = true;
      _.cardExpYearErr = false;
      _.cardExpMonthFixErr = false;

      return;
    }

    if(cardExpMonthFix > 12){
      //_.captchaErr = false;
      _.cardExpMonthFixErr = true;
      _.cardExpYearErr = false;
      _.emptyFieldTransaction = false;
      _.termsAndConditionErr = false;

      return;
    }

    if(_.cardExpYear < _.yearToday()){
      //_.captchaErr = false;
      _.cardExpYearErr = true;
      _.cardExpMonthFixErr = false;
      _.emptyFieldTransaction = false;
      return
    }

    if(!_.termsConditionsRequired){
      //_.captchaErr = false;
      _.termsAndConditionErr = true;
      _.emptyFieldTransaction = false;
      _.cardExpYearErr = false;
      _.cardExpMonthFixErr = false;

      return;
    }

    if(!_.privacyDataAllowed && _.messageDonor){
      //_.captchaErr = false;
      _.privacyDataAllowedErr = true;
      _.termsAndConditionErr = false;
      _.emptyFieldTransaction = false;
      _.cardExpYearErr = false;
      _.cardExpMonthFixErr = false;

      return;
    }

    _.showLoader = true;
    _.termsAndConditionErr = false;
    _.emptyFieldTransaction = false;
    _.privacyDataAllowedErr = false;
    _.cardExpYearErr = false;
    _.cardExpMonthFixErr = false;
    //_.captchaErr = false;

    _.apiService.createTransaction(conditions).subscribe(data => {
        _.showLoader = false;
        if(data['results'][0].transaction_status == 'Declined'){
          _.serverErr = true;
          _.serverErrText = 'Tu tarjeta ha sido declinada por el banco.';
          return;
        }
        window.scrollTo(0, 0)
        _.transactionCreated = true;
        _.transactionId = data['results'][0].transaction_id;
        _.brand = data['results'][0].brand;
        _.lastFour = data['results'][0].last4;
        _.cardBrand = data['results'][0].brand;
      },
      err => {
        _.showLoader = false;
        _.serverErr = true;
        _.serverErrText = err['error'].stack
      }
    )
  }

  createInvoice(){
    const _ = this;
    let conditions = {
      "invoice": {
        "transaction_id": _.transactionId,            // Mandatory field
        "person_id": _.personId,              // Mandatory field
        "email": _.transactionEmail,                // Mandatory field
        "legal_name": _.socialConcept,                     // Mandatory field
        "rfc": _.rfc.toUpperCase(),                         // Mandatory field
        "street": _.street,                                 // Mandatory field
        "street_number": _.extNumber,                          // Mandatory field
        "internal_number": _.intNumber,                        // Optional field
        "zip_code": _.postalCode,                            // Mandatory field
        "tax_regime": _.invoiceTaxRegimen,
        "country": _.country,                                // Mandatory field
        "township": _.municipality,                       // Mandatory field
        "city": _.township,                     // Mandatory field
        "state": _.state,                    // Mandatory field
        "locality": _.colony      // Mandatory field
      },
      "merchant": _.getMerchant()                            // Mandatory field
    }

    if(_.checkoutForm.get('rfcHomeInput').hasError('required')){
      _.emptyFieldInvoice = true;
      return;
    }

    if(_.checkoutForm.get('colonyHomeInput').hasError('required')){
      _.emptyFieldInvoice = true;
      return;
    }

    if(_.checkoutForm.get('extNumHomeInput').hasError('required')){
      _.emptyFieldInvoice = true;
      return;
    }

    if(_.checkoutForm.get('legalNameHomeInput').hasError('required')){
      _.emptyFieldInvoice = true;
      return;
    }

    if(_.checkoutForm.get('postalCodeHomeInput').hasError('required')){
      _.emptyFieldInvoice = true;
      return;
    }

    if(_.checkoutForm.get('streetHomeInput').hasError('required')){
      _.emptyFieldInvoice = true;
      return;
    }

    if(_.postalCodeErr && _.postalCodeForm.get('stateHomeInput').hasError('required')){
      _.emptyFieldInvoice = true;
      return;
    }

    if(_.postalCodeErr && _.postalCodeForm.get('municipalityHomeInput').hasError('required')){
      _.emptyFieldInvoice = true;
      return;
    }

    if(_.postalCodeErr && _.postalCodeForm.get('cityHomeInput').hasError('required')){
      _.emptyFieldInvoice = true;
      return;
    }

    _.emptyFieldInvoice = false;
    _.showLoader = true;

    _.apiService.createInvoice(conditions).subscribe(data => {
      _.showLoader = false;
      location.href = '/' + _.getMerchant() + '/' + _.getRaceName();
    })
  }

  getRaceAmounts(){
    const _ = this;
    let conditions = {
      "conditions":{
        "race_id": _.raceId,
      },
      "merchant": _.getMerchant()
    }
    _.apiService.getRaceAmounts(conditions).subscribe(data => {
      _.amountList = data['results'];
    })
  }

  getZipCode(){
    const _ = this;
    _.apiService.getZipCode(_.postalCode).subscribe(data => {
        _.postalCodeErr = false;
        if(!data['results']['results'][0]){
          _.postalCodeErr = true;
          return;
        }
        _.township = data['results']['results'][0].city;
        _.locality = data['results']['results'][0].locality;
        _.municipality = data['results']['results'][0].municipality;
        _.state = data['results']['results'][0].state;
      },
      err => {
        _.postalCodeErr = true;
        console.log(err);
      }
    )
  }

  changeAmount(amount, index, reward){
    const _ = this;
    let withoutDecimals: any = amount.split('.');
    _.amountSelected = withoutDecimals[0];
    _.selectedAmountIndex = index;
    _.textAmount = `${reward}`;
  }

  changeAmountPlan(planId){
    const _ = this;
    let withoutDecimals: any;

    for(let i = 0; i < _.planList.length; i++){
      if(_.planList[i].plan_id == planId){
        withoutDecimals = _.planList[i].amount.split('.');
        _.amountSelected = withoutDecimals[0];

        return;
      }
    }
  }

  changeToRecurrent(){
   const _ = this;
   _.recurrent = true;
  }

  getPlans(){
    const _ = this;
    let conditions = {
      "conditions":{
        "active": true,
      },
      "merchant": _.getMerchant()
    }

    _.apiService.getPlans(conditions).subscribe(data => {
      _.planList = data['results'];
    })
  }

  goToHome(){
    const _ = this;
    location.href = '/' + _.getMerchant() + '/' + _.getRaceName();
  }

  phoneLimitCharacters(){
    const _ = this;
    if(_.transactionPhone == undefined || _.transactionPhone == null){
      return;
    }

    if(_.transactionPhone.toString().length > 10){
     _.transactionPhone = _.transactionPhone.toString().substr(0, 10)
    }
  }

  cardLimitCharacters(){
    const _ = this;
    if(_.cardNumber == undefined || _.cardNumber == null){
      return;
    }

    if(_.cardNumber.toString().length > 16){
     _.cardNumber = _.cardNumber.toString().substr(0, 16)
    }
  }

  monthExpLimitCharacters(){
    const _ = this;
    if(_.cardExpMonth == undefined || _.cardExpMonth == null){
      return;
    }

    if(_.cardExpMonth.toString().length > 2){
     _.cardExpMonth = _.cardExpMonth.toString().substr(0, 2)
    }
  }

  yearExpLimitCharacters(){
    const _ = this;
    if(_.cardExpYear == undefined || _.cardExpYear == null){
      return;
    }

    if(_.cardExpYear.toString().length > 2){
     _.cardExpYear = _.cardExpYear.toString().substr(0, 2)
    }
  }

  cvvExpLimitCharacters(){
    const _ = this;
    if(_.cardCvv == undefined || _.cardCvv == null){
      return;
    }

    if(_.cardCvv.toString().length > 4){
     _.cardCvv = _.cardCvv.toString().substr(0, 4)
    }
  }

  getPages(){
    const _ = this;
    let conditions = {
      "conditions": {
        "title": "Aviso de privacidad"
      },
      "race_id": _.raceId,
      "merchant": _.getMerchant(),
    }

    _.apiService.getPages(conditions).subscribe(data => {
      _.privacyUrl = data['results'][0].url;
    })
  }

  whereIsPrivacy(url){
    const _ = this;
    let isHttps = url.indexOf('http');

    if(url == ''){
      return;
    }

    if(isHttps != -1){
      return url;
    }

    return '/' + _.getMerchant() + '/' + _.getRaceName() + '/dynamic/' + url
  }

  donorAgain(){
    const _ = this;
    _.donorCreated = false;
  }

  validateTransactionData(){
    const _ = this;
    let isAmountLessThanAllowed = parseInt(_.amountSelected) < 60;
    let isAmountGreaterThanAllowed = parseInt(_.amountSelected) > 120000;

    // if(_.captchaApproved == ''){
    //   _.captchaErr = true;
    //   _.greaterThanAllowedErr = false;
    //   _.lessThanAllowedErr = false;
    //   return false;
    // }

    if(isAmountLessThanAllowed){
      _.lessThanAllowedErr = true;
      return false;
    }

    if(isAmountGreaterThanAllowed){
      _.greaterThanAllowedErr = true;
      _.lessThanAllowedErr = false;
      console.log('pa')
      return false;
    }

    if(
      _.checkoutForm.get('emailHomeInput').hasError('required') ||
      _.checkoutForm.get('phoneHomeInput').hasError('required') ||
      _.checkoutForm.get('nameHomeInput').hasError('required') ||
      _.checkoutForm.get('lastNameHomeInput').hasError('required') ||
      _.checkoutForm.get('aliasHomeInput').hasError('required') && _.messageDonor && !_.anonymous ||
      _.checkoutForm.get('rfcHomeInput').hasError('required') && _.iNeedInvoice
    ){
      //_.captchaErr = false;
      _.emptyFieldDonor = true;
      _.greaterThanAllowedErr = false;
      _.lessThanAllowedErr = false;

      return false;
    }

    if(!_.selectedAmountIndex && (_.amountSelected == "" || _.amountSelected == null) && !_.isPlan){
      _.hasNotAmountErr = true;
      _.emptyFieldDonor = false;
      //_.captchaErr = false;
      _.greaterThanAllowedErr = false;
      _.lessThanAllowedErr = false;

      return false;
    }

    if(_.checkoutForm.get('emailHomeInput').hasError('pattern')){
      _.emailRegexErr = true;
      _.emptyFieldDonor = false;
      _.hasNotAmountErr = false;
      //_.captchaErr = false;
      _.greaterThanAllowedErr = false;
      _.lessThanAllowedErr = false;

      return false;
    }

    if(_.checkoutForm.get('rfcHomeInput').hasError('pattern') && _.iNeedInvoice){
      _.rfcRegexErr = true;
      _.emailRegexErr = false;
      _.emptyFieldDonor = false;
      _.hasNotAmountErr = false;
      //_.captchaErr = false;
      _.greaterThanAllowedErr = false;
      _.lessThanAllowedErr = false;

      return false;
    }

    if(_.checkoutForm.get('phoneHomeInput').hasError('pattern')){
      _.phoneRegexErr = true;
      _.rfcRegexErr = false;
      _.emailRegexErr = false;
      _.emptyFieldDonor = false;
      _.hasNotAmountErr = false;
      //_.captchaErr = false;
      _.greaterThanAllowedErr = false;
      _.lessThanAllowedErr = false;

      return false;
    }

    _.phoneRegexErr = false;
    _.emptyFieldDonor = false;
    _.hasNotAmountErr = false;
    _.rfcRegexErr = false;
    //_.captchaErr = false;
    _.emailRegexErr = false;
    _.showLoader = true;

    return true;
  }

  async transactionOnOneStep(){
    const _ = this;
    let transactionPhone = _.transactionPhone.toString();
    let transactionEmail = _.transactionEmail.replace(/ /g, "");
    let conditions = {
    	"transaction": {
    		"team_id": _.teamId,                        // Mandatory field
    		"collector_id": _.transactionCollectorId,                   // Mandatory field
    		"name": _.transactionName,                                    // Mandatory field
    		"lastname": _.transactionLastName,                                     // Mandatory field
    		"phone": transactionPhone,                                  // Mandatory field
    		"email": transactionEmail,                         // Mandatory field
    		"anonymous": _.anonymous,                                      // Mandatory field
    		"message": _.msgTransaction,                                          // Optional field
    		"name_message": _.transactionAlias,                                     // Optional field
    		"amount": _.amountSelected,                                          // Mandatory field
    		"invoice": _.iNeedInvoice,                                        // Mandatory field
        "tax_id": _.rfc                               // Mandatory field if invoice is true
    	},
    	"merchant": _.getMerchant(),
    	"race_url": _.getRaceName()
    };

    if(!_.validateTransactionData()) return;
    await _.apiService.createTransactionOnOneStep(conditions).subscribe(data => {
        let submitFormBtn: HTMLElement = document.querySelector('.submit-bbva') as HTMLElement;
        // _.urlResponse = data['url'];
        _.transactionIdBbva = data['transaction_id'];
        setTimeout(() => {
          submitFormBtn.click();
        }, 800)
      },
      err => {
        console.log(err);
        throw err;
      }
    )
  }

  receivePayment(){
    const _ = this;
    let conditions = {
    	"transaction": {
    		"url": "U2FsdGVkX19JfLSLmKyIVYAl8lHF/V0eCPV2+CWzeSA=",           // Mandatory field
    		"transactionId": 248,                                            // Mandatory field
    		"status": "OK"                                                   // Mandatory field only 'OK' or 'Error'
    	},
    	"merchant": "tasf",
    	"race_url": "carrera_asf_2019"
    };
    _.apiService.sendReceivedPayment(conditions).subscribe(data => {
        console.log(data);
      },
      err => {
        console.log(err);
      }
    )
  }

  shareWithFb(){
    const _ = this;
    let getDomain: any = location.href.split('/');
    getDomain = getDomain[0] + '//' + getDomain[2];
    (window as any).FB.ui({
      method: 'share_open_graph',
      action_type: 'og.shares',
      action_properties: JSON.stringify({
        object: {
          'og:url': getDomain + '/' + _.getMerchant() + '/' + _.getRaceName() + '/' + _.collectorTeam + '/' + _.collectorUsername, // your url to share
          'og:title': '6th Virtual Race',
          'og:site_name':'American School Foundation',
          'og:description':'Our 6th Virtual Race is here to honor our values of diversity and inclusiviness with the goal to raise $500,000 MXN for our Endowment found for Financial Aid',
          'og:image': 'https://carreravirtualmt.blob.core.windows.net/logos/logoh-carrera_asf_2019.png',
          'og:image:width':'250',
          'og:image:height':'257'
        }
      })
    }, function(response){});
  }

  createAlias(){
    const _ = this;
    _.transactionAlias = _.transactionName + ' ' + _.transactionLastName;
  }

  anonymousDonation(){
    const _ = this;
    let aliasInput = <HTMLInputElement>document.querySelector('#alias-donative')
    if(_.anonymous){
      _.transactionAlias = '';
      aliasInput.disabled = true;
      _.withoutAlias = true;
      return;
    }
    aliasInput.disabled = false;
    _.withoutAlias = false;
  }

  justNumbersCard(ngModel){
    const _ = this;
    _.cardNumber = ngModel.replace(/[^0-9]+/g, '');
  }

  justNumbersMonthExp(ngModel){
    const _ = this;
    if(typeof ngModel == "string"){
      _.cardExpMonth = ngModel.replace(/[^0-9]+/g, '');
    }
  }

  justNumbersYearExp(ngModel){
    const _ = this;
    if(typeof ngModel == "string"){
      _.cardExpYear = ngModel.replace(/[^0-9]+/g, '');
    }
  }

  isValidMonth(month){
    if(month < 10){
      month = '0' + month
    }

    return month.toString().length == 2;
  }

  clipBoard(){
    const _ = this;
    let urlSplit: any = location.href.split('/');
    let url = urlSplit[0] + '//' + urlSplit[2] + '/' + urlSplit[3] + '/' + urlSplit[4] + '/' + urlSplit[5] + '/' + urlSplit[6];
    _.copiedClipboard = true;
    const el = document.createElement('textarea');
    el.value = url;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    const selected =
      document.getSelection().rangeCount > 0
        ? document.getSelection().getRangeAt(0)
        : false;
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    if (selected) {
      document.getSelection().removeAllRanges();
      document.getSelection().addRange(selected);
    }
    setTimeout(() => {
      _.copiedClipboard = false;
    }, 2000)
  }

  // captchaIsResolved(captchaResponse: string) {
  //   const _ = this;
  //   _.captchaApproved = captchaResponse;
  // }

  upLabel(labelName, inputName){
    const _ = this;
    let labelTopUp = document.querySelector('.' + labelName);
    let allUpLabels = document.getElementsByClassName('label-up-active');
    let inputToFocus = document.querySelector('.' + inputName);

    (<HTMLInputElement>inputToFocus).focus();
    labelTopUp.classList.add('label-up-active');
    _.donorPastInput = inputToFocus;
  }

  downLabel(labelName, inputName){
    let placeholderElement = document.querySelector('.' + labelName);
    let inputPlaceholderElement = (<HTMLInputElement>document.querySelector('.' + inputName));

    if(inputPlaceholderElement.value == ''){
      placeholderElement.classList.remove('label-up-active');
    }
  }

  insertNumberHolder(e){
    const _ = this;
    let cardNumberLength;
    let subStringFourDigits;
    let cardPlaceholder = 'X';
    let blockOfNumber = [];
    let copyPasteCard = true;

    // Elements
    if(_.cardNumber != undefined){
      cardNumberLength = _.cardNumber.toString().length;
    }

    if(cardNumberLength > 12){
      subStringFourDigits = _.cardNumber.toString().substring(12, 16);
      document.querySelector(".secret-number-block-four h4").innerHTML = subStringFourDigits;
      if(copyPasteCard){
        document.querySelector(".secret-number-block-one h4").innerHTML = cardPlaceholder.repeat(4);
        document.querySelector(".secret-number-block-two h4").innerHTML = cardPlaceholder.repeat(4);
        document.querySelector(".secret-number-block-three h4").innerHTML = cardPlaceholder.repeat(4);
      }
      return;
    }

    if(cardNumberLength > 8 ){
      copyPasteCard = false;
      document.querySelector(".secret-number-block-three h4").innerHTML = cardPlaceholder.repeat(cardNumberLength - 8);
      if((<HTMLElement> document.querySelector(".secret-number-block-four h4")).innerText.length  == 1 && e.keyCode == 8){
        document.querySelector(".secret-number-block-four h4").innerHTML = cardPlaceholder.repeat(0);
      }
      return;
    }

    if(cardNumberLength <= 4){
      copyPasteCard = false;
      document.querySelector(".secret-number-block-one h4").innerHTML = cardPlaceholder.repeat(cardNumberLength);
      if((<HTMLElement> document.querySelector(".secret-number-block-one h4")).innerText.length == 1 && e.keyCode == 8){
        document.querySelector(".secret-number-block-one h4").innerHTML = cardPlaceholder.repeat(0);
      }
      if((<HTMLElement>document.querySelector(".secret-number-block-two h4")).innerText.length == 1 && e.keyCode == 8){
        document.querySelector(".secret-number-block-two h4").innerHTML = cardPlaceholder.repeat(0);
      }
      return;
    }

    if(cardNumberLength >= 5){
      copyPasteCard = false;
      document.querySelector(".secret-number-block-two h4").innerHTML = cardPlaceholder.repeat(cardNumberLength - 4);
      if((<HTMLElement> document.querySelector(".secret-number-block-three h4")).innerText.length == 1 && e.keyCode == 8){
        document.querySelector(".secret-number-block-three h4").innerHTML = cardPlaceholder.repeat(0);
      }
      return;
    }
  }

  insertSecretSimulation(number){
    const _ = this;
    if(number == undefined || number == '' || number == null){
      _.showCvvCard = '';
      return;
    }
    if(number.toString().length == 1){
      _.showCvvCard = 'X';
      return;
    }
    if(number.toString().length == 2){
      _.showCvvCard = 'XX';
      return;
    }
    if(number.toString().length == 3){
      _.showCvvCard = 'XXX';
      return;
    }
    if(number.toString().length == 4){
      _.showCvvCard = 'XXXX';
      return;
    }
  }
}
